<script lang="ts">
    import GigayProvider from './lib/components/GigayProvider.svelte';
    import Route from './lib/components/router/Route.svelte';
    import Router from './lib/components/router/Router.svelte';
    
    import Demo from './lib/pages/Demo.svelte';
    import Home from './lib/pages/Home.svelte';
    import Subscribe from './lib/pages/Subscribe.svelte';
    import Profile from './lib/pages/Profile.svelte';
    import Login from './lib/pages/Login.svelte';
</script>

<GigayProvider>
  <Router>
    <Route path="/" component={Home} />
    <Route path="/demo" component={Demo} />
    <Route path="/subscribe" component={Subscribe} />
    <Route path="/profile" component={Profile} />
    <Route path="/login" component={Login} />
  </Router>
</GigayProvider>

<style></style>
